import { DestroyRef, inject, Injectable, signal } from '@angular/core';
import { HomeFeedSection, HomeFeedService } from '@brightside-web/desktop/feature/home-feed';
import { tap } from 'rxjs';
import { ServiceNotificationsService } from '@brightside-web/desktop/feature/service-notifications';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ServiceNotificationItem } from '@brightside-web/desktop/feature/service-notifications';
import { UrgentCardCarouselComponent } from './cards/urgent-card-carousel/urgent-card-carousel.component';

@Injectable({
  providedIn: 'root'
})
export class ServiceNotificationsCardsService {

  urgentNotifications = signal<ServiceNotificationItem[] | undefined>(undefined)

  private readonly _destroyRef = inject(DestroyRef);
  private _homeFeedService = inject(HomeFeedService);
  private _serviceNotifications = inject(ServiceNotificationsService);

  constructor() {
    this._serviceNotifications.getGroupedNotifications$().pipe(
      takeUntilDestroyed(this._destroyRef),
      tap({
        next: (notifications) => {
          if (notifications.urgent.length > 0) {
            this.urgentNotifications.set(notifications.urgent);
            this.registerUrgentNotificationCard();
          }
        }
      })
    ).subscribe();
  }

  private registerUrgentNotificationCard() {
    this._homeFeedService.registerHomeFeedCard({
      key: 'urgent-notification',
      component: 'UrgentCardCarouselComponent',
      componentRef: UrgentCardCarouselComponent,
      section: HomeFeedSection.URGENT_NOTIFICATIONS,
      order: 1,
    });
  }

  private removeUrgentNotificationCard() {
    this._homeFeedService.removeHomeFeedCard('urgent-notification', HomeFeedSection.URGENT_NOTIFICATIONS);
  }
}
